import LayoutNew from 'components/Layout/LayoutNew'
import React, { ComponentType } from 'react'
import { Route, RouteComponentProps } from 'react-router-dom'

interface OwnProps {
  component?: ComponentType<RouteComponentProps<any>> | React.ComponentType<any>
  path: string
  exact?: boolean  
  oldCss?: boolean
  contentMaxWidth?: boolean
}

export const RouteWithLayout = ({ component, path, exact, oldCss, contentMaxWidth }: OwnProps) => {
  const renderComponent = (props: RouteComponentProps) => {
    const Component = component

    return (
      <LayoutNew oldCss={oldCss} contentMaxWidth={contentMaxWidth} >
        <Component {...props} />
      </LayoutNew>
    )
  }

  return <Route exact={exact} path={path} component={renderComponent} />
}
